module.exports = __webpack_public_path__ + "img/head-img-who-we-are.e83dd2fa.png";